export const DatetimeRepresents = {
    DEPARTURE: 'DEPARTURE',
    ARRIVAL: 'ARRIVAL'
}

export const CalendarResultType = {
    ARRIVAL_LABEL: "word.arrival",
    DEPARTURE_LABEL: "word.departure"
}
